import React, { useCallback, useEffect, useMemo } from "react";

import _ from "lodash";
import { Div } from "nexcomponent-ui";
import { useSelector } from "react-redux";

import { productBrandBreadCrumb } from "../../../../Enum/Breadcrumb/ProductBrandBreadcrumb";
import { MAPPING_CODE } from "../../../../Enum/MappingCode/MappingCode";
import { ROUTER_CONSTANT } from "../../../../Enum/RouterConstant/RouterConstant";
import {
  fetchDataApprovalProductBrand,
  fetchProductBrandMappingForm,
} from "../../../../Fetch/FetchData/ProductBrandData";
import { mappingFormPageStateGroup } from "../../../../Store/StateGroup";
import CancelOverwrite from "../../../Organisms/Button/CancelOverwrite/CancelOverwrite";
import MappingForm from "../../../Organisms/Form/MappingForm/MappingForm/MappingForm";
import HeaderPageMapping from "../../../Organisms/Header/HeaderPageMapping/HeaderPageMapping";
import ModalMapping from "../../../Organisms/Modal/ModalMapping/ModalMapping";
import useQueryRoute from "../../../../Hooks/useQueryRoute";
import {
  fetchDataApprovalProductBrandPrincipal,
  fetchProductBrandPrincipalMappingForm,
} from "../../../../Fetch/FetchData/ProductBrandPrincipalData";

const ProductBrandMappingPage = (props) => {
  const { principal } = useQueryRoute();

  const [, list, , mappingForm] = useSelector(mappingFormPageStateGroup);

  const key = useMemo(
    () => (principal ? "principal_product_brand_id" : "product_brand_id"),
    [principal]
  );

  const approveFuc = useCallback(
    (data, mappingList, mappingCount) => {
      if (principal) {
        return fetchDataApprovalProductBrandPrincipal(
          props.validToken(),
          data,
          mappingList,
          mappingCount,
          props.notify,
          props.dispatch
        );
      } else {
        return fetchDataApprovalProductBrand(
          props.validToken(),
          data,
          mappingList,
          mappingCount,
          props.notify,
          props.dispatch
        );
      }
    },
    [principal, props]
  );
  const nextMapping = useCallback(
    (uniqueKey, newId, existId, mappingList) => {
      if (principal) {
        return fetchProductBrandPrincipalMappingForm(
          props.validToken(),
          props.dispatch,
          uniqueKey,
          newId,
          existId,
          mappingList,
          props.notify,
          () => props.navigate(`${ROUTER_CONSTANT.PRODUCT_BRAND.PRINCIPAL.MAPPING}`)
        );
      } else {
        return fetchProductBrandMappingForm(
          props.validToken(),
          props.dispatch,
          uniqueKey,
          newId,
          existId,
          mappingList,
          props.notify,
          () => props.navigate(ROUTER_CONSTANT.PRODUCT_BRAND.MAPPING)
        );
      }
    },
    [principal, props]
  );

  useEffect(() => {
    if (_.has(props.location.state, "data")) {
      const first = _.first(list);
      if (principal) {
        fetchProductBrandPrincipalMappingForm(
          props.validToken(),
          props.dispatch,
          "principal_product_brand_id",
          first.id,
          props.location.state.data.principal_product_brand_id,
          list,
          props.notify,
          () => props.navigate(`${ROUTER_CONSTANT.PRODUCT_BRAND.PRINCIPAL.MAPPING}`)
        );
      } else {
        fetchProductBrandMappingForm(
          props.validToken(),
          props.dispatch,
          "product_brand_id",
          first.id,
          props.location.state.data.product_brand_id,
          list,
          props.notify,
          () => props.navigate(ROUTER_CONSTANT.PRODUCT_BRAND.MAPPING)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, principal, props.location.state, props.dispatch, props.validToken]);
  return (
    <Div>
      <ModalMapping
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        listNavigate={ROUTER_CONSTANT.PRODUCT_BRAND.LIST}
        approveFuc={approveFuc}
        uniqueKey={key}
        nextMapping={nextMapping}
      />

      <HeaderPageMapping
        title={props.t("PRODUCT_BRAND:TITLE")}
        listBreadcrumb={productBrandBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRODUCT_BRAND:MAPPING.TITLE")}
        to={ROUTER_CONSTANT.PRODUCT_BRAND.LIST}
      />
      <MappingForm
        t={props.t}
        validToken={props.validToken}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey={key}
        mappingCode={MAPPING_CODE.PRODUCT_BRAND}
        mappingForm={mappingForm}
      />
      <CancelOverwrite
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey={key}
        mappingForm={mappingForm}
        mappingCode={MAPPING_CODE.PRODUCT_BRAND}
      />
    </Div>
  );
};

export default ProductBrandMappingPage;
